import envVar from '../config/envVars';
import { SchoolStructureData } from '../modules/SchoolStructure/types';
import httpGet from './httpClient/httpGet';
import httpPost from './httpClient/httpPost';

const getSchoolStructure = async (school: string) =>
  httpGet(`${envVar.REACT_APP_BASE_API_URL}/school-structures/${school}`);

const updateSchoolStructure = async (
  school: string,
  data: Partial<SchoolStructureData>
) =>
  httpPost(
    `${envVar.REACT_APP_BASE_API_URL}/school-structures/${school}`,
    data
  );

export { getSchoolStructure, updateSchoolStructure };
